import { Link } from 'react-router-dom';

const quartiers = [
  'Vaugirard', 'Grenelle', 'Javel', 'Beaugrenelle', 'Saint-Lambert',
  'Necker', 'Convention', 'Commerce', 'Cambronne', 'Pasteur',
  'Falguière', 'Front de Seine', 'Porte de Versailles',
];

export default function ZonesSection() {
  return (
    <section className="py-14 md:py-20 bg-[#e6f7f5]">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-3 font-heading">
            Nous intervenons dans tout le 15ᵉ
          </h2>
          <p className="text-sm md:text-base text-brand-text/60">
            Votre quartier n'est pas listé ? Appelez-nous — nous y allons aussi.
          </p>
        </div>

        <div className="w-full rounded-2xl overflow-hidden mb-6 border border-brand-mint/60 shadow-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2626.0!2d2.2945!3d48.8414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6701e5e1e1e1e%3A0x50b82c368941b0!2sParis%2015!5e0!3m2!1sfr!2sfr!4v1718400000000"
            width="100%"
            height="400"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Paris 15ᵉ — Zones d'intervention DF PRO"
            className="w-full h-[400px]"
          ></iframe>
        </div>

        <div className="mb-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <div className="hidden sm:flex items-center gap-1.5">
            <div className="w-2.5 h-2.5 rounded-full bg-brand-accent/60 flex-shrink-0"></div>
            <div className="h-0.5 w-12 md:w-20 bg-gradient-to-r from-brand-accent/60 to-brand-gradientTo/60 rounded-full"></div>
            <div className="w-2 h-2 rounded-full bg-brand-gradientTo/60 flex-shrink-0"></div>
            <div className="h-0.5 w-12 md:w-20 bg-gradient-to-r from-brand-gradientTo/60 to-brand-gradientTo/30 rounded-full"></div>
            <div className="w-1.5 h-1.5 rounded-full bg-brand-gradientTo/30 flex-shrink-0"></div>
          </div>
          <span className="text-xs md:text-sm text-brand-text/60 font-medium">
            De Vaugirard à Beaugrenelle — nous couvrons tous les quartiers du 15ᵉ
          </span>
          <div className="hidden sm:flex items-center gap-1.5">
            <div className="w-1.5 h-1.5 rounded-full bg-brand-gradientTo/30 flex-shrink-0"></div>
            <div className="h-0.5 w-12 md:w-20 bg-gradient-to-r from-brand-gradientTo/30 to-brand-accent/60 rounded-full"></div>
            <div className="w-2 h-2 rounded-full bg-brand-accent/60 flex-shrink-0"></div>
            <div className="h-0.5 w-12 md:w-20 bg-gradient-to-r from-brand-accent/60 to-brand-accent/60 rounded-full"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-brand-accent/60 flex-shrink-0"></div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5 md:gap-4">
          {quartiers.map((q) => (
            <Link
              key={q}
              to="/zones-intervention-paris-15/"
              className="flex items-center gap-2 px-3 md:px-4 py-3 bg-white hover:bg-brand-mint/60 rounded-xl border border-brand-mint/60 hover:border-brand-accent/30 transition-all cursor-pointer shadow-sm"
            >
              <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full bg-brand-accent/10 flex-shrink-0">
                <i className="ri-map-pin-fill text-brand-accent text-xs md:text-sm"></i>
              </div>
              <span className="text-xs md:text-sm font-semibold text-brand-dark whitespace-nowrap truncate">{q}</span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="tel:+33187668155" className="inline-flex items-center gap-2 text-sm text-brand-text/60 hover:text-brand-accent transition-colors cursor-pointer">
            <i className="ri-phone-fill"></i>
            <span className="font-medium">Contact : 01 87 66 81 55</span>
          </a>
        </div>
      </div>
    </section>
  );
}